<template>
    <div class="in-app-top-banner">
        <InAppPreviewLayout>
            <template v-slot:vertical>
                <div class="preview preview-vertical">
                    <div
                        class="preview-block"
                        :style="{
                            background:
                                template.InAppProps.Styling
                                    .MessageBackgroundColor,
                        }"
                    >
                        <a
                            v-if="
                                template.InAppProps.Image.URL &&
                                template.InAppProps.Image.URL.length
                            "
                            :href="template.InAppProps.Image.ActionURL"
                            class="preview-block-image"
                            :style="{
                                background:
                                    'url(' +
                                    template.InAppProps.Image.URL +
                                    ') no-repeat center / cover',
                            }"
                            target="_blank"
                        >
                        </a>
                        <div class="preview-block-text">
                            <p
                                class="title"
                                :style="{
                                    color:
                                        template.InAppProps.Styling.Title.Color,
                                }"
                            >
                                {{ template.Title || template.Subject }}
                            </p>
                            <p class="describtion">
                                {{ template.Template }}
                            </p>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:horizontal>
                <div class="preview preview-horizontal">
                    <div
                        class="preview-block"
                        :style="{
                            background:
                                template.InAppProps.Styling
                                    .MessageBackgroundColor,
                        }"
                    >
                        <a
                            v-if="
                                template.InAppProps.Image.URL &&
                                template.InAppProps.Image.URL.length
                            "
                            :href="template.InAppProps.Image.ActionURL"
                            class="preview-block-image"
                            :style="{
                                background:
                                    'url(' +
                                    template.InAppProps.Image.URL +
                                    ') no-repeat center / cover',
                            }"
                            target="_blank"
                        >
                        </a>
                        <div class="preview-block-text">
                            <p
                                class="title"
                                :style="{
                                    color:
                                        template.InAppProps.Styling.Title.Color,
                                }"
                            >
                                {{ template.Title || template.Subject }}
                            </p>
                            <p class="describtion">
                                {{ template.Template }}
                            </p>
                        </div>
                    </div>
                </div>
            </template>
        </InAppPreviewLayout>
    </div>
</template>

<script>
import InAppPreviewLayout from "../InAppPreviewLayout.vue";
export default {
    name: "in-app-top-banner",
    components: {
        InAppPreviewLayout,
    },
    props: {
        template: {
            type: Object,
            default: null,
        },
    }
};
</script>

<style lang="scss">
.in-app-top-banner {
    .preview {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-start;
    }
    .preview-vertical {
        padding-top: 55px;
        padding-left: 35px;
        padding-right: 35px;
        @media screen and (max-width: 1600px) {
            padding-left: 30px;
            padding-right: 30px;
        }
        @media screen and (max-width: 1366px) {
            padding-left: 25px;
            padding-right: 25px;
        }
    }
    .preview-horizontal {
        padding-top: 40px;
        padding-left: 45px;
        padding-right: 55px;
    }
    .preview-block {
        background: #ffffff;
        border-radius: 10px;
        width: 100%;
        min-height: 37px;
        background: #ffffff;
        border-radius: 10px;
        display: flex;
        padding: 8px 14px;
        height: max-content;
        @media screen and (max-width: 1600px) {
            padding: 8px;
        }
    }
    .preview-block-image {
        width: 35px;
        height: 35px;
        border-radius: 3px;
        display: flex;
        flex-shrink: 0;
        margin-right: 10px;
    }
    .preview-block-text {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        p {
            font-size: 7px;
            line-height: 8px;
            color: #000000;
            margin: 0;
        }
        .title {
            font-weight: bold;
            font-size: 8px;
            line-height: 9px;
            margin-bottom: 4px;
            overflow: hidden;
        }
    }
}
</style>
